"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHelpDeskState = void 0;
var react_1 = require("react");
var useGlobalState_1 = require("./useGlobalState");
var keys_1 = require("../keys");
var useHelpDeskState = function () {
    var _a = (0, useGlobalState_1.useGlobalState)(keys_1.globalStateKeys.HELP_DESK_OPEN, false), state = _a.state, changeState = _a.changeState;
    return (0, react_1.useMemo)(function () { return ({
        helpDeskStatus: state,
        changeHelpDeskStatus: changeState,
    }); }, [state, changeState]);
};
exports.useHelpDeskState = useHelpDeskState;
